export default () => ({
  username: "",
  password: "",
  loading: false,
  error: "",

  async submit() {
    this.error = "";
    this.loading = true;
    try {
      const form = new URLSearchParams();
      form.append("username", this.username);
      form.append("password", this.password);
      const res = await fetch("/v1/auth/web/login", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: form,
      });
      if (res.status === 204 || res.ok) {
        window.location.href = "/admin/dashboard";
      } else if (res.status === 400) {
        this.error = "Invalid email or password.";
      } else {
        this.error = "Something went wrong. Please try again.";
      }
    } catch {
      this.error = "Unable to connect. Please check your network.";
    } finally {
      this.loading = false;
    }
  },
});
